import React from 'react'
import { MinimumWageTable } from './MinimumWageTable'
import './MinimumWage.scss'

export default function() {
    return (
        <div>
            <h3 className='minimum-wage-title'>Minimum Wages</h3>
            <MinimumWageTable />
        </div>
    )
}